import type { ReactNode } from "react"

import { Toaster } from "@/components/ui/sonner"
import { useBfcacheReload } from "@/hooks/use-bfcache-reload"
import { useCable } from "@/hooks/use-cable"
import { useFlash } from "@/hooks/use-flash"
import { TimeProvider } from "@/hooks/use-time"

interface PersistentLayoutProps {
  children: ReactNode
}

export default function PersistentLayout({ children }: PersistentLayoutProps) {
  useFlash()
  useBfcacheReload() // Reload when restored from back-forward cache
  useCable() // Initialize Action Cable connection

  return (
    <TimeProvider>
      {children}
      <Toaster richColors />
    </TimeProvider>
  )
}
